<xemex-page-header
  [title]="userProfile?.fullName ?? ''"
  [subtitle]="
    companyName && roleNameKey
      ? companyName + ' • ' + (roleNameKey | translate)
      : companyName || (roleNameKey ? (roleNameKey | translate) : '')
  "
  [loading]="userStore.isLoading()"
  [imageUrl]="avatarUrl()"
  [icon]="'person'"
  [withBackground]="true"
  [breadcrumbs]="[
    { label: 'sidebarMenu.home' | translate, routerLink: '/' },
    { label: 'header.userMenu.myProfile' | translate },
  ]"
></xemex-page-header>

<xemex-page-body [scrollable]="true">
  <xemex-card-grid>
    <xemex-card
      [title]="'myProfile.tabs.info.title' | translate"
      [actionLabel]="'general.btnEdit' | translate"
      [loading]="userStore.isLoading()"
      (action)="onEditProfile()"
    >
      <div class="grid grid-cols-2 gap-4">
        <xemex-detail-field
          [label]="'myProfile.tabs.info.content.firstName' | translate"
          [loading]="userStore.isLoading()"
        >
          {{ userProfile?.firstName }}
        </xemex-detail-field>
        <xemex-detail-field
          [label]="'myProfile.tabs.info.content.lastName' | translate"
          [loading]="userStore.isLoading()"
        >
          {{ userProfile?.lastName }}
        </xemex-detail-field>
        <xemex-detail-field
          [label]="'myProfile.tabs.info.content.email' | translate"
          [loading]="userStore.isLoading()"
        >
          {{ userProfile?.email }}
        </xemex-detail-field>
        <xemex-detail-field
          [label]="'myProfile.tabs.info.content.phone' | translate"
          [loading]="userStore.isLoading()"
        >
          {{ userProfile?.phone }}
        </xemex-detail-field>
        <xemex-detail-field
          [label]="'myProfile.tabs.info.content.language' | translate"
          [loading]="userStore.isLoading()"
        >
          {{ languageLabel | translate }}
        </xemex-detail-field>
      </div>
    </xemex-card>

    <xemex-card
      [title]="'myProfile.tabs.security.title' | translate"
      [actionLabel]="'myProfile.tabs.security.content.btnUpdatePassword' | translate"
      [loading]="userStore.isLoading()"
      (action)="onChangePassword()"
    >
      <div class="grid grid-cols-2 gap-4">
        <xemex-detail-field
          [label]="'myProfile.tabs.security.content.oldPassword' | translate"
          [loading]="userStore.isLoading()"
        >
          ••••••••
        </xemex-detail-field>
      </div>
    </xemex-card>
  </xemex-card-grid>
</xemex-page-body>
